import React from "react";
import PropTypes from "prop-types";
import StoreFilter from "./StoreFilter";
import NonCategoryFilterOption from "./NonCategoryFilterOption";
import ColorFilterOption from "./ColorFilterOption";
import style from "../../stylesheets/StoreFilter.module.scss";
import { COLOR_FACET_ID } from "../../constants";

function NonCategoryFilter(props) {
  const {
    facetFilter,
    selectedDropdown,
    showDropdown,
    isMobile,
    mobileHandleFilterClick,
    correspondingFacetParamTagIds,
    clearMultiSelectFilter,
    handleFilterClick,
  } = props;

  if (facetFilter.active_facet_tags.length === 0) {
    return null;
  }

  const handleClearFilter = () => {
    const filterToBeCleared = {
      facet_id: facetFilter.facet.id,
    };

    clearMultiSelectFilter(filterToBeCleared);
  };

  const selectedFilters = [];

  const filterOptions = facetFilter.active_facet_tags.map((filterOption) => {
    filterOption.count = filterOption.count || 0;

    let isCurrentFilter = false;
    correspondingFacetParamTagIds.forEach((filterId) => {
      if (Number(filterId) === filterOption.id) {
        isCurrentFilter = true;
        selectedFilters.push(filterOption);
      }
    });

    const filterOptionComponent = () => {
      if (filterOption.facet_id === COLOR_FACET_ID) {
        if (
          filterOption.metadata &&
          filterOption.metadata.hex &&
          filterOption.metadata.hex.length > 0
        ) {
          return (
            <ColorFilterOption
              key={filterOption.id}
              facetName={facetFilter.facet.display_name}
              filterOption={filterOption}
              isCurrentFilter={isCurrentFilter}
              handleFilterClick={handleFilterClick}
              isMobile={isMobile}
              mobileHandleFilterClick={mobileHandleFilterClick}
            />
          );
        }

        return null;
      }

      return (
        <NonCategoryFilterOption
          key={filterOption.id}
          facetName={facetFilter.facet.display_name}
          filterOption={filterOption}
          isCurrentFilter={isCurrentFilter}
          handleFilterClick={handleFilterClick}
          isMobile={isMobile}
          mobileHandleFilterClick={mobileHandleFilterClick}
        />
      );
    };

    return filterOptionComponent();
  });

  const clearOption =
    isMobile || correspondingFacetParamTagIds.length === 0 ? null : (
      <div className={style.clearFilter} onClick={handleClearFilter}>
        Clear all
      </div>
    );

  const storeFilterProps = {
    facetFilter,
    selectedDropdown,
    showDropdown,
    isMobile,
    selectedFilters,
  };

  const scrollableFilterDropdown =
    facetFilter.facet.id === COLOR_FACET_ID
      ? ""
      : style.scrollableFilterDropdown;

  return (
    <StoreFilter {...storeFilterProps}>
      <ul className={scrollableFilterDropdown}>{filterOptions}</ul>
      {clearOption}
    </StoreFilter>
  );
}

NonCategoryFilter.propTypes = {
  facetFilter: PropTypes.object.isRequired,
  selectedDropdown: PropTypes.number.isRequired,
  showDropdown: PropTypes.func.isRequired,
  correspondingFacetParamTagIds: PropTypes.array.isRequired,
  clearMultiSelectFilter: PropTypes.func.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
  mobileHandleFilterClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default NonCategoryFilter;
